<template>
  <div class="cinema-carousel">
    <!-- CARRUSEL EN MOVIMIENTO -->
    <div
      class="marquee"
      :class="{ 'is-paused': isPaused }"
      @mouseenter="pause"
      @mouseleave="play"
    >
      <div class="marquee-inner">
        <!-- Bloque 1 -->
        <div
          v-for="(image, index) in images"
          :key="'a-' + index"
          class="marquee-item"
          @click="enlargeImage(index)"
        >
          <img
            :src="image"
            :alt="'Imagen ' + (index + 1)"
            class="marquee-image"
          />
        </div>

        <!-- Bloque 2 (duplicado para que el loop sea continuo) -->
        <div
          v-for="(image, index) in images"
          :key="'b-' + index"
          class="marquee-item"
          @click="enlargeImage(index)"
        >
          <img
            :src="image"
            :alt="'Imagen ' + (index + 1)"
            class="marquee-image"
          />
        </div>
      </div>
    </div>

    <!-- MODAL IMAGEN AMPLIADA -->
    <div
      v-if="isImageEnlarged"
      class="image-modal"
      @click.self="closeModal"
    >
      <img
        :src="images[currentIndex]"
        class="enlarged-image"
        alt="Foto ampliada"
      />
      <button class="modal-close" type="button" @click="closeModal">×</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CinemaCarousel',
  data() {
    return {
      currentIndex: 0,
      isImageEnlarged: false,
      isPaused: false,
      images: [
        require('@/assets/_HDB0149.webp'),
                require('@/assets/foto_webp_max.webp'),

               require('@/assets/mariana_-106.jpeg'),


        
      ],
    };
  },
  methods: {
    enlargeImage(index) {
      this.currentIndex = index;
      this.isImageEnlarged = true;
      this.isPaused = true;
    },
    closeModal() {
      this.isImageEnlarged = false;
      this.isPaused = false;
    },
    pause() {
      this.isPaused = true;
    },
    play() {
      if (!this.isImageEnlarged) {
        this.isPaused = false;
      }
    },
  },
};
</script>

<style scoped>
.cinema-carousel {
  position: relative;
  width: 100%;
  max-width: 1100px;
  margin: 0px auto;
  padding: 0px 0;
  overflow: hidden;
  background: #dad5cd;
}

/* CONTENEDOR MARQUEE */
.marquee {
  width: 100%;
  overflow: hidden;
}

/* TIRA DE IMÁGENES */
.marquee-inner {
  display: flex;
  width: max-content;
  animation: marquee-move 35s linear infinite;
}

/* Pausa animación */
.marquee.is-paused .marquee-inner {
  animation-play-state: paused;
}

/* CADA FOTO */
.marquee-item {
  flex: 0 0 auto;
  width: 220px !important;
height: 420px !important;
  margin: 0 10px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.18);
  cursor: pointer;
  transform: translateY(0);
  transition: transform 0.5s ease, box-shadow 0.5s ease;
}

/* Efecto cine al hover */
.marquee-item:hover {
  transform: translateY(-10px) scale(1.03);
  box-shadow: 0 26px 60px rgba(0, 0, 0, 0.28);
}

/* IMAGEN */
.marquee-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* ANIMACIÓN CONTINUA */
@keyframes marquee-move {
  0% {
    transform: translateX(0);
  }
  100% {
    /* como duplicamos el bloque, -50% hace loop perfecto */
    transform: translateX(-50%);
  }
}

/* MODAL */
.image-modal {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.enlarged-image {
  max-width: 90%;
  max-height: 85%;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.7);
  object-fit: contain;
}

/* BOTÓN CERRAR */
.modal-close {
  position: absolute;
  top: 18px;
  right: 22px;
  font-size: 30px;
  background: none;
  border: none;
  color: #ffffff;
  cursor: pointer;
}

/* RESPONSIVE */
@media (max-width: 600px) {
  .marquee-item {
    width: 190px;
    height: 270px;
    margin: 0 8px;
  }
}
</style>
